import { ExperimentStatusKind } from '@gonfalon/experiments/types';
import type { TagProps } from '@launchpad-ui/components';

export const EXPERIMENT_STATUS_TAG_MAP: Record<string, TagProps['variant']> = {
  [ExperimentStatusKind.NOT_STARTED]: 'default',
  [ExperimentStatusKind.RUNNING]: 'info',
  [ExperimentStatusKind.STOPPED]: 'warning',
};
